import Head from 'next/head';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Header } from '@/components/Header/Header';
import { Footer } from '../Footer/Footer';
import styles from './MclLayout.module.scss';
import type * as Types from '@/pages/mijn-carel-lurvink/catalogus/stores/types';

interface ILayoutProps {
  children?: React.ReactNode;
  theme?: AppTheme;
  categories: Types.Category[];
}

export const ContentPageLayout = ({ children, categories }: ILayoutProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.mclLayout}>
      <Head>
        <title>{t('common:mijn-carellurvink.page-title')}</title>
      </Head>

      <div className={styles.header}>
        <Header categories={categories} />
      </div>

      <main className={styles.main}>{children}</main>
      <div className={styles.footer}>
        <Footer />
      </div>
    </div>
  );
};
